import api from '@/services/chat';

export const apiSignIn = async (
  payload: {
    email: string;
    password: string;
    remember?: boolean;
  }
) => {
  return await api.post(
    '/doctor/auth/sign-in',
    { remember: payload.remember },
    { auth: { username: payload.email, password: payload.password } }
  );
};